/**
 * Chat-pane aurora — port of C:\ukisai\fongpt frontend/src/index.css `.aurora-bg-static`.
 * Lives only inside the chat column so it cannot smear the sidenav brand.
 */
export default function HaloBackground() {
  return <div className="aurora-bg-static" aria-hidden="true" />;
}
